module.exports = __webpack_public_path__ + "static/media/logo-avast.ec3158ad.png";